import { useDispatch } from 'react-redux';
import { setactiveItem } from 'store/cards';

export const useRemoveActiveItem = () => {
  const dispatch = useDispatch();

  const removeActiveItem = () => {
    dispatch(setactiveItem(null));
  };

return removeActiveItem;
}
